__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@shipbob/b_2_b_operations_packing_mfe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@fortawesome/fontawesome-svg-core", "6.7.2", () => (__webpack_require__.e(107).then(() => (() => (__webpack_require__(37107))))));
			register("@fortawesome/free-solid-svg-icons", "6.7.2", () => (__webpack_require__.e(188).then(() => (() => (__webpack_require__(66188))))));
			register("@fortawesome/vue-fontawesome", "3.1.2", () => (Promise.all([__webpack_require__.e(838), __webpack_require__.e(856), __webpack_require__.e(273)]).then(() => (() => (__webpack_require__(61273))))));
			register("@shipbob/auth", "1.2.0", () => (__webpack_require__.e(667).then(() => (() => (__webpack_require__(13667))))));
			register("@shipbob/hardware", "1.19.0", () => (__webpack_require__.e(612).then(() => (() => (__webpack_require__(7612))))));
			register("@shipbob/telemetry", "1.9.0", () => (__webpack_require__.e(36).then(() => (() => (__webpack_require__(21036))))));
			register("@xstate/vue", "2.0.0", () => (Promise.all([__webpack_require__.e(849), __webpack_require__.e(457), __webpack_require__.e(340)]).then(() => (() => (__webpack_require__(6340))))));
			register("axios", "1.20.0", () => (__webpack_require__.e(69).then(() => (() => (__webpack_require__(87069))))));
			register("vue-axios", "3.5.2", () => (__webpack_require__.e(21).then(() => (() => (__webpack_require__(31021))))));
			register("vue-router", "4.6.3", () => (Promise.all([__webpack_require__.e(523), __webpack_require__.e(352)]).then(() => (() => (__webpack_require__(33523))))));
			register("vue", "3.5.41", () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))));
			register("vuex", "4.0.2", () => (Promise.all([__webpack_require__.e(124), __webpack_require__.e(143)]).then(() => (() => (__webpack_require__(82124))))));
			register("xstate", "4.38.3", () => (__webpack_require__.e(948).then(() => (() => (__webpack_require__(51948))))));
			initExternal(14330);
			initExternal(53366);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};